// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { cartActionsStyles } from "@rugby/Overrides/Widgets/Cart/CartActions";
import { screen } from "@rugby/XDL/Helpers";
import { css } from "styled-components";

cartActionsStyles.exportCartClickable = {
    css: css`
        color: ${getColor("secondary")};
        font-size: 15px;
        letter-spacing: 0;
        line-height: 30px;
        text-align: right;
        margin-left: 50px;
        ${screen("lte", "sm")`
                margin: 0;
                display: flex !important;
                & > span {
                    padding: 0 !important;
                    display: inline-flex !important;
                    width: auto !important;
                    line-height: 18px;
                }
            `};

        &:hover {
            color: ${getColor("link")};
        }

        & svg {
            color: ${getColor("secondary")};
            width: 16px;
            height: 16px;
            margin-right: 5px;
        }
    `,
};
